import { useEffect, useState } from "react";
import RiskAssessmentCard from "../../../../../shared/ui/RiskScoreCard/RiskAssessmentCard";
import { getTenantRiskFactors } from "../../../../../shared/services/apis";
import { useParams } from "react-router-dom";
import RiskSkeleton from "../../../../../shared/ui/RiskScoreCard/RiskSkeleton";

// --- Separated weight functions ---
const getLeverageWeight = (taskName: string): string => {
  const taskLower = taskName.toLowerCase();
  if (taskLower.includes("ltv at acquisition")) return "10%";
  if (taskLower.includes("debt yield at acquisition")) return "10%";
  if (taskLower.includes("ltv post full earnout. drawdown")) return "15%";
  if (taskLower.includes("initial loan term")) return "5%";
  if (taskLower.includes("i/o term")) return "10%";
  if (taskLower.includes("excess earnout available")) return "0%";
  if (taskLower.includes("no. of loan extensions")) return "0%";
  if (taskLower.includes("extensions and rollovers")) return "10%";
  if (taskLower.includes("prepayment flexibility")) return "5%";
  if (taskLower.includes("noi cushion for dscr/dy")) return "10%";
  if (taskLower.includes("noi cushions for extension tests")) return "25%";
  return "0%";
};

const getSensitivityWeight = (taskName: string): string => {
  const taskLower = taskName.toLowerCase();
  if (taskLower.includes("irr sensitivity to interest rates")) return "10%";
  if (taskLower.includes("irr sensitivity to revenue growth")) return "10%";
  if (taskLower.includes("irr sensitivity to exit cap rate")) return "20%";
  if (taskLower.includes("property moic")) return "20%";
  if (taskLower.includes("property cash yield")) return "40%";
  return "0%";
};

interface Props {
  RiskFactorId: string;
}

export function FinancialPositionRiskCard({ RiskFactorId }: Props) {
  const [selectedSubRiskId, setSelectedSubRiskId] = useState<string>("");
  const { tenantId } = useParams<{ tenantId: string }>();
  const [subRiskFactor, setSubRiskFactor] = useState<any[]>([]);
  const [riskPerimeters, setRiskPerimeters] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const refreshRiskScorecard = async () => {
      try {
        setLoading(true);
        console.log(tenantId, "it is in riskscroeooo");
        const response = await getTenantRiskFactors(tenantId || "");
        const riskFactors = response.data || response;
        console.log(riskFactors, "it is in financial position");

        const selectedRiskFactor = riskFactors.find(
          (factor: any) => factor.id === RiskFactorId
        );

        if (selectedRiskFactor) {
          const subFactors = selectedRiskFactor.subRiskFactors.map(
            (sub: any) => ({
              id: sub.id,
              name: sub.name,
              tenantId: sub.tenantRiskFactorId,
              weight: sub.weight,
            })
          );

          setSubRiskFactor(subFactors);

          // Set default selection to first sub-risk factor
          if (subFactors.length > 0 && !selectedSubRiskId) {
            setSelectedSubRiskId(subFactors[0].id);
          }

          const defaultSubRiskId =
            subFactors.length > 0 ? subFactors[0].id : "";
          if (!selectedSubRiskId) setSelectedSubRiskId(defaultSubRiskId);

          // Set risk perimeters based on currently selected sub-risk factor
          // const currentSubRiskId = selectedSubRiskId || defaultSubRiskId;
          setRiskPerimeters(
            selectedRiskFactor.factorGroups
              .filter((group: any) => group.riskFactorId === RiskFactorId)
              .flatMap(
                (group: any) =>
                  group.result?.ratings?.map((rating: any) => ({
                    task: rating.task,
                    rating: rating.rating,
                    reasoning: rating.reasoning,
                    subRiskFactorId: group.subRiskFactorId,
                  })) || []
              )
          );
        } else {
          setSubRiskFactor([]);
          setRiskPerimeters([]);
        }

        console.log(subRiskFactor, "sub Facuturrdsssss");
        console.log(riskPerimeters, "risk parameters");
      } catch (error) {
        console.error("Failed to fetch risk factors:", error);
      } finally {
        setLoading(false);
      }
    };

    refreshRiskScorecard();
  }, [tenantId, RiskFactorId, selectedSubRiskId]);

  useEffect(() => {
    console.log(riskPerimeters, "freee use effect");
  }, [subRiskFactor, riskPerimeters]);

  // Filter risk parameters by selected sub-risk factor
  // const filteredRiskPerimeters = {
  //   ratings: riskPerimeters
  //     .filter((param) => param.subRiskFactorId === selectedSubRiskId)
  //     .map((param) => ({
  //       task: param.task,
  //       rating: param.rating,
  //       reasoning: param.reasoning,
  //     })),
  // };

  // Get weight function based on selected sub-risk factor
  // const getWeightFunction = () => {
  //   const selectedSubFactor = subRiskFactor.find(
  //     (sub) => sub.id === selectedSubRiskId
  //   );
  //   const subFactorName = selectedSubFactor?.name?.toLowerCase() || "";

  //   if (subFactorName.includes("leverage")) {
  //     return getLeverageWeight;
  //   } else if (
  //     subFactorName.includes("sensitivity") ||
  //     subFactorName.includes("downside")
  //   ) {
  //     return getSensitivityWeight;
  //   }
  //   return getLeverageWeight; // default
  // };

  // Show loading state
  if (loading) {
    return <RiskSkeleton />;
  }

  // Don't render until we have data
  if (subRiskFactor.length === 0) {
    return <div>No risk data available</div>;
  }

  return (
    <div className="px-4">
      {/* Show buttons only if more than one subRiskFactor exists */}
      {/* {subRiskFactor.length > 1 && (
        <div className="flex justify-center space-x-2 mb-4">
          {subRiskFactor.map((subFactor) => (
            <button
              key={subFactor.id}
              className={`px-3 py-1 text-sm font-light rounded-2xl border cursor-pointer transition-colors duration-200 ${
                selectedSubRiskId === subFactor.id
                  ? "bg-gray-50 text-gray-700 border-gray-300"
                  : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50"
              }`}
              onClick={() => setSelectedSubRiskId(subFactor.id)}
            >
              {subFactor.name}
            </button>
          ))}
        </div>
      )} */}

      {/* Render RiskAssessmentCard for each subRiskFactor */}
      {subRiskFactor.map((sub) => {
        const subFiltered = {
          ratings: riskPerimeters
            .filter((param) => param.subRiskFactorId === sub.id)
            .map((param) => ({
              task: param.task,
              rating: param.rating,
              reasoning: param.reasoning,
            })),
        };

        const getWeightFunction = () => {
          const subName = sub.name.toLowerCase();
          if (subName.includes("leverage")) return getLeverageWeight;
          if (subName.includes("sensitivity") || subName.includes("downside"))
            return getSensitivityWeight;
          return getLeverageWeight;
        };

        return (
          <RiskAssessmentCard
            key={sub.id}
            title={sub.name || "Financial Position Risk"}
            apiResponse={subFiltered}
            getWeightForTask={getWeightFunction()}
          />
        );
      })}
    </div>
  );
}
